import React from 'react';
import { useIntl } from 'ha/i18n';
import { City } from 'ha/services/apiV2/types';

import { filterHiddenCities, citiesToFeaturedLinks } from '../../utils';

import {
  FeaturedLinksTitle,
  FeaturedLinksWrapper,
  FeaturedLinksContent,
  FeaturedLink,
  Spacer,
} from '../FeaturedLinks/FeaturedLinks';

interface Props {
  featuredCities?: City[];
}

export const FeaturedCities: React.FC<Props> = ({ featuredCities = [] }) => {
  const { T } = useIntl();

  if (featuredCities.length === 0) {
    return null;
  }

  const cities: City[] = filterHiddenCities(featuredCities);
  const featuredLinks: FeaturedLink[] = citiesToFeaturedLinks(cities);

  return (
    <FeaturedLinksWrapper>
      <Spacer>
        <FeaturedLinksTitle
          titles={[
            T('Hundreds cities around the world!'),
            T('Where will you go?'),
          ]}
        />
      </Spacer>
      <FeaturedLinksContent items={featuredLinks} maxItemsPerColumn={8} />
    </FeaturedLinksWrapper>
  );
};
